<template>
  <a-form-model ref='form' layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}"  :rules="rules">
    <a-form-model-item label='质疑对象表单' prop='formId' >
      <a-select v-model='model.formId' placeholder='请选择表单' @change="formIdChange()" showSearch :filterOption="filterOption">
        <a-select-option :value='item.id' :key="item.id" v-for="item in formList">{{item.name}}</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label='质疑对象' prop='formItemId' >
      <a-select v-model='model.formItemId' placeholder='请选择元素' showSearch :filterOption="filterOption">
        <a-select-option :value='item.id' :key="item.id" v-for="item in formItemList">{{(item.number?item.number:"")+item.name}}</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label='质疑周期规则' prop='periodType' >
      <a-radio-group v-model='model.periodType' :options='radioOptions' @change="periodTypeChange"/>
    </a-form-model-item>
    <a-form-model-item  v-if='model.periodType==="2" ' label="周期" prop='periodItemId' >
      <a-select v-model='model.periodItemId' placeholder='请选择周期' >
        <a-select-option :value='item.id' :key="item.id" v-for="item in periodItemList">{{item.name}}</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item   label="质疑程度" prop='level' >
      <a-radio-group v-model='model.level' style="width: 200px" >
        <a-radio value="1">
          普通质疑
        </a-radio>
        <a-radio value="2">
          严重质疑
        </a-radio>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item   label="质疑类别" prop='category' >      
      <a-checkbox-group v-model="categorys" @change="categorysChange">
        <a-checkbox v-for="(item, key) in categoryList" :key="key" :value="item.id">{{ item.name }}</a-checkbox>
      </a-checkbox-group>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
  import { getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
export default {
  name: 'Step1',
  data() {
    return {
      model:{},
      // radioOptions: [{ label: '所有周期', value: '1' }, { label: '指定周期', value: '2' }],
      radioOptions: [{ label: '所有周期', value: '1' }],
      rules: {
        formId:[baseRules.requiredChange],
        formItemId:[baseRules.requiredChange],
        periodItemId:[baseRules.requiredChange],
      },
      formList:[],
      formItemList:[],
      periodItemList:[],
      categoryList:[{"id":1,"name":"数据核查"},{"id":2,"name":"质疑提示"}],
      categorys:[1,2]
    }
  },
  created() {
    
  },
  mounted(){
    
  },
  methods: {
    view(model){
      if(!model.periodType){
        model.periodType = '1'
      }      
      if(!model.level){
        model.level = '1'
      }
      this.model = JSON.parse(JSON.stringify(model))
      getAction('/tempconfig/tempConfigForm/listAll',{}).then(res=>{
        if(res.success){
          this.formList=res.result
          this.formIdChange(true)
        }
      })
      
      console.log("this.model.category view:"+this.model.category)
      
      if(this.model.category>=0){
        this.categorys=[]
        if((this.model.category & 1)==1){
          this.categorys.push(1)
        }
        if((this.model.category & 2)==2){
          this.categorys.push(2)
        }
      }else{
        this.categorys=[1,2]
        this.categorysChange()
      }
      this.periodTypeChange()
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.form.validate((valid, errorFields) => {
        if (valid) {
          result = true
        }
      })
      return result
    },
    formIdChange(edit){
      this.formItemList = []
      if(this.model.formItemId && !edit){
        this.model.formItemId = null
      }
    if(this.model.formId){
            let formCode;
            for (let item of this.formList) {
              if (item.id === this.model.formId) {
                formCode = item.code
                break
              }
            }
            getAction('/tempconfig/tempConfigFormItem/listAll',{formCode:formCode,scale:'0'}).then(res=>{
              if(res.success){
                this.formItemList = res.result
              }
            })
          }      
    },
    periodTypeChange(){
      // if(this.periodItemList.length===0 && this.model.periodType==='2'){
      //   getAction('/project/projectPeriodItem/list',{projectId:this.model.projectId,halfway:'0'}).then(res=>{
      //     if(res.success){
      //       this.periodItemList=res.result
      //     }
      //   })
      // }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    categorysChange(){      
      console.log("categorys:"+ this.categorys)
      let category = 0
      this.categorys.forEach(item=>{
        category += item
      })
      this.model.category = category
      console.log("this.model.category:"+this.model.category)
    }
  }
}
</script>

<style scoped>

</style>
